var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 39,
    viewBox: "0 0 43 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.694 3.1609L7.98068 8.62456H3.60918C2.67217 8.62456 1.77353 8.9653 1.11097 9.57183C0.448398 10.1784 0.0761719 11.001 0.0761719 11.8588V15.9166L1.26091 16.4578C7.47485 19.302 14.3268 20.7827 21.2742 20.7827C28.2216 20.7827 35.0736 19.302 41.2875 16.4578L42.4722 15.9166V11.8588C42.4722 11.001 42.1 10.1784 41.4374 9.57183C40.7749 8.9653 39.8762 8.62456 38.9392 8.62456H34.5677L31.8544 3.1609C31.3867 2.21846 30.6325 1.41922 29.6818 0.858693C28.7312 0.298166 27.6244 6.07603e-05 26.4936 0H16.0548C14.924 6.07603e-05 13.8172 0.298166 12.8666 0.858693C11.9159 1.41922 11.1617 2.21846 10.694 3.1609ZM16.0548 4.31228C15.8288 4.31234 15.6075 4.37193 15.4175 4.48395C15.2275 4.59597 15.0767 4.75569 14.9831 4.94403L13.1554 8.62456H29.393L27.5653 4.94403C27.4717 4.75569 27.3209 4.59597 27.1309 4.48395C26.9409 4.37193 26.7196 4.31234 26.4936 4.31228H16.0548Z",
    fill: "#73C7A9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42.4722 20.7268C36.5652 23.2931 30.1606 24.761 23.6295 25.0456V28.0297C23.6295 28.6015 23.3814 29.1499 22.9397 29.5543C22.498 29.9586 21.8989 30.1858 21.2742 30.1858C20.6495 30.1858 20.0504 29.9586 19.6087 29.5543C19.167 29.1499 18.9189 28.6015 18.9189 28.0297V25.0456C12.4652 24.7631 6.05873 23.325 0.0761719 20.7268V35.5761C0.0761719 36.4339 0.448398 37.2565 1.11097 37.8631C1.77353 38.4696 2.67217 38.8103 3.60918 38.8103H38.9392C39.8762 38.8103 40.7749 38.4696 41.4374 37.8631C42.1 37.2565 42.4722 36.4339 42.4722 35.5761V20.7268Z",
    fill: "#73C7A9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup2);
export default __webpack_public_path__ + "static/media/group2.122f7582d131448ad340f93e66b0a93a.svg";
export { ForwardRef as ReactComponent };